import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.acc.production,
  name: sharedEnvironment.acc.name,
  ansokanUrl: sharedEnvironment.acc.ansokanUrl,
  bpUrl: sharedEnvironment.acc.bpUrl,
  etjansterCommonUrl: sharedEnvironment.acc.etjansterCommonUrl,
  cookieDomain: sharedEnvironment.acc.cookieDomain,
  ansokanApiUrl: `${sharedEnvironment.acc.gatewayUrl}/ansok`,
  featureUrl: `${sharedEnvironment.acc.gatewayUrl}/ansok/feature`,
  ansokanSignalRUrl: `${sharedEnvironment.acc.gatewayUrl}/ansok`,
  etjansterCommonApiUrl: `${sharedEnvironment.acc.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring/ansokan`,
  sprakHanteringApiUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.acc.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.acc.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.acc.projektUrl,
  chatbotApiUrl: `${sharedEnvironment.acc.gatewayUrl}/ansok/chatbot`,
  externalLinks: sharedEnvironment.acc.externalLinks,
  baseGatewayUrl: sharedEnvironment.acc.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.acc.apimSubscriptionKey,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      `${sharedEnvironment.acc.gatewayUrl}/ansok`,
      sharedEnvironment.acc.azureAdB2C.clientId.ansokanClientId,
      sharedEnvironment.acc.azureAdB2C.clientId.ansokanApiClientId,
    ),
    authority: sharedEnvironment.acc.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.acc.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.acc.azureAdB2C.clientId.ansokanApiClientId}/all`,
    tenant: sharedEnvironment.acc.azureAdB2C.tenant,
    policies: sharedEnvironment.acc.azureAdB2C.policies,
    clientId: sharedEnvironment.acc.azureAdB2C.clientId,
  },
  ga4MeasurementId: sharedEnvironment.acc.ga4MeasurementId,
};
